<template>
  <b-card class="profile-card">
    <div v-if="isLoading" class="loading-wrap">
      <b-spinner label="Loading..." />
    </div>

    <div v-else>
      <div class="profile-head d-flex align-items-center">
        <b-img :src="logoImage" width="72" height="72" class="profile-logo" />
        <h4 class="mb-0 ml-1 profile-title">{{ profileTitle }}</h4>
      </div>

      <div class="profile-form-wrap">
        <b-row>
          <b-col md="6">
            <b-form-group label="First Name" label-for="first-name" class="label">
              <b-form-input id="first-name" :value="firstname || 'John'" disabled />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Last Name" label-for="last-name" class="label">
              <b-form-input id="last-name" :value="lastname || 'Doe'" disabled />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Phone Number" label-for="phone" class="label">
              <b-form-input id="phone" :value="phone || '674 758 7365'" disabled />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Email Address" label-for="email" class="label">
              <b-form-input id="email" :value="email || 'Address'" disabled />
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label="Address" label-for="address" class="label">
              <b-form-input id="address" :value="address || 'California'" disabled />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Zip Code" label-for="zip" class="label">
              <b-form-input id="zip" :value="pincode || '34753'" disabled />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Country" label-for="country" class="label">
              <b-form-input id="country" :value="countryName || 'USA'" disabled />
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-button :to="{ name: 'profile-edit-account-setting' }" variant="light" class="edit-btn">Edit</b-button>
          </b-col>
        </b-row>
      </div>
    </div>
  </b-card>
</template>

<script>
import { BButton, BCard, BCol, BFormGroup, BFormInput, BImg, BRow, BSpinner } from 'bootstrap-vue'
import { getUserData } from '@/auth/utils'
import { adminPanelApi } from '@/services/adminPanelApi'

export default {
  components: {
    BButton,
    BCard,
    BCol,
    BFormGroup,
    BFormInput,
    BImg,
    BRow,
    BSpinner,
  },
  data() {
    let user = null
    try {
      user = JSON.parse(localStorage.getItem('userData') || 'null')
    } catch {
      user = null
    }
    return {
      accessToken: localStorage.getItem('accessToken'),
      baseApi: process.env.VUE_APP_APIENDPOINT,
      user,
      isLoading: false,
      firstname: '',
      lastname: '',
      phone: '',
      email: '',
      address: '',
      pincode: '',
      countryName: '',
      logoImage: require('@/assets/images/logo/logo.png'),
    }
  },
  computed: {
    profileTitle() {
      return this.user && this.user.f_name ? this.user.f_name.toUpperCase() : 'PODA'
    },
  },
  mounted() {
    this.user = getUserData()
    this.getProfile()
  },
  methods: {
    async getProfile() {
      this.isLoading = true
      const adminId = this.user?.id || getUserData()?.id
      if (!adminId) {
        this.isLoading = false
        return
      }
      try {
        const res = await adminPanelApi.adminProfile(adminId)
        const data = res?.data?.data || {}
        this.firstname = data.f_name || ''
        this.lastname = data.l_name || ''
        this.phone = data.phone || ''
        this.email = data.email || ''
        this.address = data.address || ''
        this.pincode = data.pincode || ''
        this.countryName = data.country?.name || data.country_name || ''
      } catch (error) {
        console.log(error, 'error')
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.profile-card {
  border: 1px solid #ebe9f1;
}

.loading-wrap {
  min-height: 380px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.profile-head {
  border-bottom: 1px solid #ebe9f1;
  padding: 1.4rem 1.2rem;
}

.profile-logo {
  border-radius: 6px;
  object-fit: cover;
}

.profile-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #2f2b3d;
}

.profile-form-wrap {
  padding: 1rem 1.2rem 1.35rem;
}

.label {
  font-size: 0.82rem;
  color: #6e6b7b;
}

.edit-btn {
  color: #a8aaae;
  background: #f2f2f3 !important;
  border-color: #f2f2f3 !important;
  min-width: 72px;
}
</style>
